export default {
  subtotal: 'Subtotal',
  tip: 'Bacșiș',
  discount: 'Reducere',
  method_fee: 'Taxă de livrare',
  service_fee: {
    title: 'Taxă de serviciu',
    description:
      'Această mică taxă de serviciu ne ajută să acoperim costurile aferente fiecărei comenzi — cum ar fi trimiterea actualizărilor prin SMS, funcționarea platformei noastre de comandă online și gestionarea taxelor suplimentare de tranzacție. Nu-ți face griji — această taxă este mult mai mică decât ce ai plăti pe aplicațiile de livrare. Îți mulțumim pentru înțelegere și pentru că ne susții direct. Îți apreciem sprijinul!',
  },
  payment_method_upcharge_fee: {
    title: 'Taxă PayPal',
    description:
      'De fiecare dată când un client plătește cu PayPal, PayPal percepe taxe de 6-7%. Deci pe 100€, pierdem 6-7€. Prin urmare, din păcate trebuie să adăugăm un supliment de 3,5% pentru utilizarea PayPal. 🤯 Te rugăm să iei în considerare una dintre celelalte metode de plată sigure și criptate la checkout. Îți suntem foarte recunoscători pentru înțelegere și sprijin! 🙏',
  },
  tax: 'Taxe',
  total: 'Total',
  earned_points: 'Ai câștigat {{points}} puncte',
};
